// extracted by mini-css-extract-plugin
export var description = "homePage-module--description--E9L4o";
export var heading = "homePage-module--heading--rYSeI";
export var homeContent = "homePage-module--homeContent--MFi3K";
export var homeH = "homePage-module--homeH--+gWUj";
export var homeLogoContainer = "homePage-module--homeLogoContainer--FZY5X";
export var homePageContainer = "homePage-module--homePageContainer--ChKWH";
export var homePageContainerParent = "homePage-module--homePageContainerParent--EBVYX";
export var hpCover = "homePage-module--hpCover--b8tV7";
export var lowerNewsContainer = "homePage-module--lowerNewsContainer--FNhv5";
export var lowerfelxElement = "homePage-module--lowerfelxElement--nKJ7Q";
export var moreButton = "homePage-module--moreButton--Edzam";
export var title = "homePage-module--title--RSe+N";
export var titleContainer = "homePage-module--titleContainer--Q-fWy";
export var titleNewsContainerContent = "homePage-module--titleNewsContainerContent--wwsAE";
export var titleNewsSectionContainer = "homePage-module--titleNewsSectionContainer--ML7Ma";
export var titleNewsWrapper = "homePage-module--titleNewsWrapper--XqskV";
export var upperContentContainer = "homePage-module--upperContentContainer--Kc7Ot";
export var upperFlexElement = "homePage-module--upperFlexElement--zuRle";